import { render, staticRenderFns } from "./OptimizedScoreSummary.vue?vue&type=template&id=23b9264c&scoped=true"
import script from "./OptimizedScoreSummary.vue?vue&type=script&lang=js"
export * from "./OptimizedScoreSummary.vue?vue&type=script&lang=js"
import style0 from "./OptimizedScoreSummary.vue?vue&type=style&index=0&id=23b9264c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b9264c",
  null
  
)

export default component.exports